import { EnumTipoItemTexto } from "../enums/EnumTipoItemTexto";
import { Versao } from "./Versao";
import { TextoPagina } from "./pagina/TextoPagina";

export class ItemTexto {
  id: string;
  // idConjunto: string;
  idLei: string;
  itemCitacao: string;
  versao: Versao;
  versoes: Array<Versao>;
  // identificador: string;
  tipoItem: EnumTipoItemTexto;
  tipoNaoIdentificado: boolean;

  constructor() {
    this.versoes = new Array<Versao>();
  }
}

export class FuncoesItem {
  public static identificarTipoItem(itemTexto: TextoPagina): EnumTipoItemTexto {
    let ret: EnumTipoItemTexto;

    switch (itemTexto.tipoTexto) {
      case "texto-tituloprincipal":
        ret = EnumTipoItemTexto.tituloPrincipal;
        break;
      case "texto-preambulo":
        ret = EnumTipoItemTexto.preambulo;
        break;
      case "texto-parte":
        ret = EnumTipoItemTexto.parte;
        break;
      case "texto-livro":
        ret = EnumTipoItemTexto.livro;
        break;
      case "texto-titulo":
        ret = EnumTipoItemTexto.titulo;
        break;
      case "texto-ementa":
        ret = EnumTipoItemTexto.ementa;
        break;
      case "texto-capitulo":
        ret = EnumTipoItemTexto.capitulo;
        break;
      case "texto-secao":
        ret = EnumTipoItemTexto.secao;
        break;
      case "texto-subsecao":
        ret = EnumTipoItemTexto.subSecao;
        break;
      case "texto-artigo":
        ret = EnumTipoItemTexto.artigo;
        break;
      case "texto-paragrafo":
        ret = EnumTipoItemTexto.paragrafo;
        break;
      case "texto-inciso":
        ret = EnumTipoItemTexto.inciso;
        break;
      case "texto-alinea":
        ret = EnumTipoItemTexto.alinea;
        break;
      case "texto-rodape":
        ret = EnumTipoItemTexto.rodape;
        break;
      case "texto-sumula":
        ret = EnumTipoItemTexto.sumula;
        break;
      case "texto-linhatabela":
        ret = EnumTipoItemTexto.linhaTabela;
        break;
      case "texto-desconhecido":
        ret = EnumTipoItemTexto.desconhecido;
        break;
    }

    return ret;
  }

  static descreverTipoItem(item: Partial<ItemTexto>): string {
    let ret = "Desconhecido";
    const citacao = item.itemCitacao ? " citacao" : "";

    if (item.tipoNaoIdentificado) {
      return ret;
    }

    switch (item.tipoItem) {
      case 1:
        ret = "TituloPrincipal";
        break;
      case 2:
        ret = "Preambulo";
        break;
      case 3:
        ret = "Parte";
        break;
      case 4:
        ret = "Livro";
        break;
      case 5:
        ret = "Titulo";
        break;
      case 6:
        ret = "Ementa";
        break;
      case 7:
        ret = "Capitulo";
        break;
      case 8:
        ret = "Secao";
        break;
      case 9:
        ret = "SubSecao";
        break;
      case 10:
        ret = "Artigo";
        break;
      case 11:
        ret = "Paragrafo";
        break;
      case 12:
        ret = "Inciso";
        break;
      case 13:
        ret = "Alinea";
        break;
      case 14:
        ret = "Rodape";
        break;
      case 15:
        ret = "Sumula";
        break;
      case 16:
        ret = "Inciso";
        break;
      case 17:
        ret = "Rodape";
        break;
      case 18:
        // O tratamento do front deve ser igual ao paragrafo comum
        ret = "Paragrafo";
        break;
      case 19:
        // O tratamento do front deve ser igual a alinea comum
        ret = "Alinea";
        break;
      case 20:
        // O tratamento do front deve ser igual ao inciso comum
        ret = "Inciso";
        break;
      case 98:
        ret = "LinhaTabela";
    }

    return ret + citacao;
  }
}
